import { compose } from 'recompose';
import Service from './Service';
import apiInterceptor from '../../../api/interceptor';
import { catalogsApi, buApi } from '../../common/base.api';

const composedService = compose(apiInterceptor({ ...catalogsApi, getBUList: buApi.getList }))(Service);

export default composedService;
